import React, { Component } from 'react';
import Header from '../header/header';
import Content from '../content/content';
import $ from 'jquery';



class IndustryReportCategory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rpt_des: {
                description:{
                    full_description:''
                },
                content:{
                    table:''
                }
            },
            slug   : props.match.params.slug,
            sub    : props.match.params.sub,
            error: null,
            count:0,
            isLoaded:true
        };

    }
    render() {
        return (
            <div>
                <Header />
                {/*Inside Content Of Report Page*/}
                <section class="ovrfl">
                    <div class="container">
                        <div class="row breadcrumb text-center trght">
                            <div class="col-md-12">
                                <a href="/">
                                    <span>Home</span>
                                </a>
                                <i class="fa fa-angle-right"></i>
                                <a href="/industry-reports">
                                    <span>Industry Reports</span>
                                </a>
                            </div>
                        </div>


                        <div class="container">
                            <div class="hidden-lg hidden-sm hidden-md">
                                <div class="container">
                                    <h5 class="">
                                        <a onClick={this.expand.bind(this)}>
                                        <span id="list">
                                            <i class="fa fa-list-ul"></i>
                                        </span>CATEGORIES
                                            <span id="back" class="tright" >
                                            <i class="fa fa-arrow-left"></i>
                                        </span>
                                        </a>
                                    </h5>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12" id="prntt">

                                    <Content slug={this.state.slug} sub={this.state.sub} location={this.props.location} />

                                </div>


                            </div>




                        </div>




                    </div>
                </section>
            </div>
        );
    }


     expand(){
        if (this.state.count===0){
            $("#list").fadeOut(100);
            $('.cate_reports').css("margin-left","280px");
            $('.cate_reports .report_card').css("width",'50%');

            $('.cate_reports').css("margin-right","-280px");

            $('.cate_sidemenu').css("margin-left","0px");



            $("#back").fadeIn(250);
            this.setState(
                {
                    count:1
                }
            )

        }
        else{
            $("#back").fadeOut(100);
            $('.cate_reports').css("margin-left","0px");
            $('.cate_reports .report_card').css("width",'100%');
            $('.cate_reports').css("margin-right","0px");
            $('.cate_sidemenu').css("margin-left","-280px");

            $("#list").fadeIn(250);
            this.setState(
                {
                    count:0
                }
            )
        }
    }

}


export default IndustryReportCategory;


// WEBPACK FOOTER //
// ./src/industry-reports/industry-report-category/industry-report-category.js